import controller from './thing-details-labels.controller';

const template = require('./thing-details-labels.html');

export default {
    bindings: {
        suffix: '@',
        labels: '<',
        alwaysEditable: '<',
        availableLabelKeys: '<',
        labelContext: '@', // 'device' or 'project' to determine display text
        validateFilterKeys: '<', // when true, keys are used as alert/rule filters and must not contain whitespace (the rules API rejects them)
        onLabelAdd: '&',
        onLabelChange: '&',
        onLabelRemove: '&'
    },
    template,
    controller
};
